import Events from "@/utils/Events";
import TagManagerEvents from "./TagManager";
import { sendGTMGA4Event } from "./TagManagerGa4";
import Apm from "@/utils/Apm";
import { nativeEvents } from "./events/native-events-ga4";

type dataEvents = {
    genericCategory: string;
    genericAction: string;
    genericLabel: string
}

const gtm_id = "GTM-NR2VZP3";

const setEvents = ({genericCategory, genericAction, genericLabel}: dataEvents) => {
    TagManagerEvents.push(gtm_id, {
        event: "genericEvent",
        genericCategory,
        genericAction,
        genericLabel
    });
}

/**
 * Para ativar o debug mode e ver os disparos pelo console do navegador, basta colocar no parametro de url 'debug=1'
 * @param events
 * @constructor
 */
 const ListenerEvents = (events: Events) => {
    // Observando todos os eventos
     events.addEventListener("*", (_data, key) => {
         events.sendHotjarEvent(key);
         Apm.startTransactionEvent(key, _data);
     })
    events = nativeEvents(events)

    events.addEventListener("detalhes_oferta_abrir", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: data.show ? "detalhes_oferta_abrir" : "detalhes_oferta_fechar",
        });

        const { offer_type, show } = data

        events.push(() => {
            sendGTMGA4Event({
                secao: 'geral',
                nome_campo: 'detalhes_oferta',
                tipo_acao:  show ? 'abrir' : 'fechar',
                tipo_oferta: offer_type || ''
            })
        })
    });

    events.addEventListener("identificacao_cadastro_visualizado", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "identificacao_cadastro_visualizado",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_cadastro',
            tipo_acao: 'show',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_faca_o_login", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_faca_o_login",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_cadastro',
            nome_campo: 'faca_o_login',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_cadastro_nome", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_cadastro_nome",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_cadastro',
            nome_campo: 'nome_completo',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_cadastro_email", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_cadastro_email",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_cadastro',
            nome_campo: 'email',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_cadastro_senha", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_cadastro_senha",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_cadastro',
            nome_campo: 'senha',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_cadastro_confirme_senha", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_cadastro_confirme_senha",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_cadastro',
            nome_campo: 'confirme_senha',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_login_visualizado", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "identificacao_login_visualizado",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_login',
            tipo_acao: 'show',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_login_cadastre_se", (data) => {
        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_login',
            nome_campo: 'cadastre_se',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_login_email", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_login_email",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_login',
            nome_campo: 'email',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_login_erro_email", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "identificacao_login_erro_email",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_login',
            nome_campo: 'email',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_login_senha", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_login_senha",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_login',
            nome_campo: 'senha',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_login_erro_senha", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "identificacao_login_erro_senha",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_login',
            nome_campo: 'senha',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_login_sucesso", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "identificacao_login_sucesso",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_login',
            nome_campo: 'sucesso',
            tipo_acao: 'show',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_login_error", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "identificacao_login_error",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_login',
            nome_campo: 'email_ou_senha_incorreto',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_login_esqueci_minha_senha", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_login_esqueci_minha_senha",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_login',
            nome_campo: 'esqueci_minha_senha',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_termos_de_uso", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_termos_de_uso",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'geral',
            nome_campo: 'termos_de_uso',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        });
    });

    events.addEventListener("identificacao_politica_de_privacidade", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_politica_de_privacidade",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'geral',
            nome_campo: 'politica_de_privacidade',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        });
    });

    events.addEventListener("identificacao_login_continuar", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_login_continuar",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_login',
            nome_campo: 'continuar',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        });

        sendGTMGA4Event({
            event: "login",
            method: 'Interno',
        });
    });

    events.addEventListener("restaurar_senha_visualizado", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "restaurar_senha_visualizado",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'restaurar_senha',
            tipo_acao: 'show',
            tipo_oferta: offer_type || ''
        })
    });


    events.addEventListener("restaurar_senha_email", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "restaurar_senha_email",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'restaurar_senha',
            nome_campo: 'email',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });
    events.addEventListener("restaurar_senha_enviar", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "restaurar_senha_enviar",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'restaurar_senha',
            nome_campo: 'enviar_mensagem',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });
    events.addEventListener("restaurar_senha_sucesso", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "restaurar_senha_sucesso",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'restaurar_senha',
            nome_campo: 'sucesso',
            tipo_acao: 'show',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("restaurar_senha_erro_email", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "restaurar_senha_erro_email",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'restaurar_senha',
            nome_campo: 'email',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_cadastro_continuar", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_cadastro_continuar",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_cadastro',
            nome_campo: 'continuar',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })

        sendGTMGA4Event({
            event: "sign_up",
            method: 'Interno',
        });
    });

    events.addEventListener("identificacao_cadastro_sucesso", () => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "identificacao_cadastro_sucesso",
        });
    });

    events.addEventListener("identificacao_cadastro_erro_nome", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "identificacao_cadastro_erro_nome",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_cadastro',
            nome_campo: 'nome',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_cadastro_erro_email", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "identificacao_cadastro_erro_email",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_cadastro',
            nome_campo: 'email',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_cadastro_erro_senha", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "identificacao_cadastro_erro_senha",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_cadastro',
            nome_campo: 'senha',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_cadastro_erro_confirme_senha", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "identificacao_cadastro_erro_confirme_senha",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_cadastro',
            nome_campo: 'confirme_senha',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("precisa_de_ajuda_abrir", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: data.show ? "precisa_de_ajuda_abrir" : "precisa_de_ajuda_fechar",
        });

        const { offer_type, show } = data

        sendGTMGA4Event({
            secao: 'geral',
            nome_campo: 'precisa_de_ajuda',
            tipo_acao:  show ? 'abrir' : 'fechar',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("restaurar_senha_chat_abrir", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: data.show ? "restaurar_senha_chat_abrir" : "restaurar_senha_chat_fechar",
        });

        const { offer_type, show } = data

        sendGTMGA4Event({
            secao: 'restaurar_senha',
            nome_campo: 'chat',
            tipo_acao:  show ? 'abrir' : 'fechar',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("restaurar_senha_mensagem_abrir", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: data.show ? "restaurar_senha_mensagem_abrir" : "restaurar_senha_mensagem_fechar",
        });

        const { show, offer_type } = data

        events.push(()=>{
            sendGTMGA4Event({
                secao: 'restaurar_senha',
                nome_campo: 'mensagem',
                tipo_acao: show ? 'abrir' : 'fechar',
                tipo_oferta: offer_type || ''
            })
        })
    });

    events.addEventListener("detalhes_oferta_alterar_plano", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "detalhes_oferta_alterar_plano",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'geral',
            nome_campo: 'alterar_plano',
            tipo_acao:  'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("precisa_de_ajuda_sac_capitais", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "precisa_de_ajuda_sac_capitais",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'geral',
            nome_campo: 'sac_capitais',
            tipo_acao:  'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("precisa_de_ajuda_sac_demais_localidades", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "precisa_de_ajuda_sac_demais_localidades",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'geral',
            nome_campo: 'sac_demais_localidades',
            tipo_acao:  'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("precisa_de_ajuda_televendas_telefone", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "precisa_de_ajuda_televendas_telefone",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'geral',
            nome_campo: 'televendas_telefone',
            tipo_acao:  'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("precisa_de_ajuda_televendas_whatsapp", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "precisa_de_ajuda_televendas_whatsapp",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'geral',
            nome_campo: 'televendas_whatsapp',
            tipo_acao:  'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_login_google", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_login_google",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'geral',
            nome_campo: 'login_google',
            tipo_acao:  'click',
            tipo_oferta: offer_type || ''
        })

        sendGTMGA4Event({
            event: "login",
            method: 'Google',
        });
    });

    events.addEventListener("identificacao_login_facebook", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_login_facebook",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'geral',
            nome_campo: 'login_facebook',
            tipo_acao:  'click',
            tipo_oferta: offer_type || ''
        });

        sendGTMGA4Event({
            event: "login",
            method: 'Facebook',
        });
    });

    events.addEventListener("identificacao_logado_visualizado", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "identificacao_logado_visualizado",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_logado',
            tipo_acao: 'show',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_logado_trocar_usuario", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_logado_trocar_usuario",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_logado',
            nome_campo: 'trocar_usuario',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_logado_continuar", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_logado_continuar",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_logado',
            nome_campo: 'continuar',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("identificacao_logado_continuar_sucesso", () => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "identificacao_logado_continuar_sucesso",
        });
    });

    events.addEventListener("metodo_pagamento_visualizado", () => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "metodo_pagamento_visualizado",
        });
    });

    events.addEventListener("metodo_pagamento_cartao", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "metodo_pagamento_cartao",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'metodo_pagamento',
            nome_campo: 'cartao',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("metodo_pagamento_debito", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "metodo_pagamento_debito",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'metodo_pagamento',
            nome_campo: 'debito',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("metodo_pagamento_paypal", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "metodo_pagamento_paypal",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'metodo_pagamento',
            nome_campo: 'paypal',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("metodo_pagamento_voltar_para_identificacao", () => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "metodo_pagamento_voltar_para_identificacao",
        });
    });


    events.addEventListener("pagamento_cartao_visualizado", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "pagamento_cartao_visualizado",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            tipo_acao: 'show',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_nome", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "pagamento_cartao_nome",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'nome',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_erro_nome", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "pagamento_cartao_erro_nome",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'nome',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_documento", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "pagamento_cartao_documento",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'documento',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_erro_documento", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "pagamento_cartao_erro_documento",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'documento',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_numero_do_cartao", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "pagamento_cartao_numero_do_cartao",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'numero_do_cartao',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_erro_numero_do_cartao", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "pagamento_cartao_erro_numero_do_cartao",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'numero_do_cartao',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_validade_do_cartao", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "pagamento_cartao_validade_do_cartao",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'validade_do_cartao',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_erro_validade_do_cartao", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "pagamento_cartao_erro_validade_do_cartao",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'validade_do_cartao',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_codigo_de_seguranca", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "pagamento_cartao_codigo_de_seguranca",
        });
        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'codigo_de_seguranca',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_erro_codigo_de_seguranca", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "pagamento_cartao_erro_codigo_de_seguranca",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'codigo_de_seguranca',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_parcelas", (data) => {
        setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "pagamento_cartao_parcelas",
        });

        const { offer_type } = data
        console.log(data)
        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'parcelas',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_recaptcha_visualizado", () => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "pagamento_cartao_recaptcha_visualizado",
        });
    });

    events.addEventListener("pagamento_cartao_recaptcha", () => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "pagamento_cartao_recaptcha",
        });
    });

    events.addEventListener("pagamento_cartao_erro_recaptcha", () => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "pagamento_cartao_erro_recaptcha",
        });
    });

    events.addEventListener("pagamento_cartao_concluir", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "pagamento_cartao_concluir",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'concluir',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_negado", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "pagamento_cartao_negado",
        })

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'pagamento_negado',
            tipo_acao: 'show',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_contrato_de_assinatura", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "pagamento_contrato_de_assinatura",
        });

        const { offer_type, paymentMethod } = data

        sendGTMGA4Event({
            secao: 'pagamento_' + paymentMethod,
            nome_campo: 'contrato_de_assinatura',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_mudar_debito", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "pagamento_cartao_mudar_debito",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'mudar_debito',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_mudar_paypal", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "pagamento_cartao_mudar_paypal",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'mudar_paypal',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("voucher_visualizado", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "voucher_visualizado",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'voucher',
            nome_campo: 'visualizado',
            tipo_acao: 'show',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("voucher_ja_utilizado", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "voucher_ja_utilizado",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'voucher',
            nome_campo: 'ja_utilizado',
            tipo_acao: 'show',
            tipo_oferta: offer_type || ''
        })
    });
    events.addEventListener("identificacao_cadastro_telefone", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "identificacao_cadastro_telefone",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'identificacao_cadastro',
            nome_campo: 'telefone',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("voucher_voltar_para_identificacao", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "voucher_voltar_para_identificacao",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'voucher',
            nome_campo: 'voltar_para_identificacao',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("atualizacao_celular_visualizado", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "atualizacao_celular",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'atualizacao_celular',
            tipo_acao: 'show',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("atualizacao_celular_celular", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "atualizacao_celular_celular",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'atualizacao_celular',
            nome_campo: 'celular',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("atualizacao_celular_continuar", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "atualizacao_celular_continuar",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'atualizacao_celular',
            nome_campo: 'continuar',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("atualizacao_celular_erro", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "erro",
            genericLabel: "atualizacao_celular_continuar",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'atualizacao_celular',
            nome_campo: 'celular',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("atualizacao_celular_outra_conta", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "atualizacao_celular_outra_conta",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'atualizacao_celular',
            nome_campo: 'entrar_outra_conta',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("voucher_codigo", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "voucher_codigo",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'voucher',
            nome_campo: 'codigo',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("voucher_erro_validar_codigo", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "voucher_erro_validar_codigo",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'voucher',
            nome_campo: 'codigo',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("voucher_telefone", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "voucher_telefone",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'voucher',
            nome_campo: 'telefone',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("voucher_validar_codigo", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "voucher_validar_codigo",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'voucher',
            nome_campo: 'validar_codigo',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("voucher_validar_codigo_sucesso", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "voucher_validar_codigo_sucesso",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'voucher',
            nome_campo: 'validar_codigo_sucesso',
            tipo_acao: 'show',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("voucher_erro_telefone", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "voucher_erro_telefone",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'voucher',
            nome_campo: 'telefone',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("voucher_preencher_documento", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "voucher_preencher_documento",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'voucher',
            nome_campo: 'documento',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("voucher_erro_preencher_documento", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "voucher_erro_preencher_documento",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'voucher',
            nome_campo: 'codigo',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("voucher_concluir", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "voucher_concluir",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'voucher',
            nome_campo: 'concluir',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("concluir_voucher_negado", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "concluir_voucher_negado",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'voucher',
            nome_campo: 'concluir_negado',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("voucher_contrato_de_assinatura", () => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "voucher_contrato_de_assinatura",
        });
    });

    events.addEventListener("pagamento_sucesso_visualizado", () => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "pagamento_sucesso_visualizado",
        });
    });

    events.addEventListener("resumo_de_pedido_visualizado", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "resumo_de_pedido_visualizado",
        });

        const { offer_type, id_pedido } = data

        sendGTMGA4Event({
            secao: 'resumo_de_pedido',
            tipo_acao: 'show',
            tipo_oferta: offer_type || '',
            id_pedido: id_pedido
        })
    });

    events.addEventListener("resumo_de_pedido_comece_a_usar", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "resumo_de_pedido_comece_a_usar",
        });

        const { offer_type, idPedido } = data

        sendGTMGA4Event({
            secao: 'resumo_de_pedido',
            nome_campo: 'comece_a_usar',
            tipo_acao: 'click',
            tipo_oferta: offer_type || '',
            id_pedido: idPedido
        })
    });

    events.addEventListener("resumo_de_pedido_onboarding", () => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "resumo_de_pedido_onboarding",
        });
    });

    events.addEventListener("detalhes_oferta_sumario_do_contrato", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "detalhes_oferta_sumario_do_contrato",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'geral',
            nome_campo: 'sumario_do_contrato',
            tipo_acao:  'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("restaurar_senha_voltar", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "restaurar_senha_voltar",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'restaurar_senha',
            nome_campo: 'voltar',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("pagamento_cartao_voltar_para_identificacao", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "pagamento_cartao_voltar_para_identificacao",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'pagamento_cartao',
            nome_campo: 'voltar_para_identificacao',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("cortesia_voltar_para_identificacao", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "cortesia_voltar_para_identificacao",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'cortesia',
            nome_campo: 'voltar_para_identificacao',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("cortesia_visualizado", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "cortesia_visualizado",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'cortesia',
            nome_campo: 'visualizado',
            tipo_acao: 'show',
            tipo_oferta: offer_type || '',
        })
    });

    events.addEventListener("cortesia_telefone", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "cortesia_telefone",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'cortesia',
            tipo_acao: 'click',
            tipo_oferta: offer_type || '',
            nome_campo: 'telefone'
        })
    });

    events.addEventListener("cortesia_erro_telefone", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "cortesia_erro_telefone",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'cortesia',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || '',
            nome_campo: 'telefone'
        })
    });

    events.addEventListener("cortesia_preencher_documento", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "cortesia_preencher_documento",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'cortesia',
            tipo_acao: 'click',
            tipo_oferta: offer_type || '',
            nome_campo: 'documento'
        })
    });

    events.addEventListener("cortesia_erro_preencher_documento", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "cortesia_erro_preencher_documento",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'cortesia',
            tipo_acao: 'erro',
            tipo_oferta: offer_type || '',
            nome_campo: 'documento'
        })
    });

    events.addEventListener("cortesia_concluir", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "cortesia_concluir",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'cortesia',
            tipo_acao: 'click',
            nome_campo: 'concluir',
            tipo_oferta: offer_type || '',
        })
    });

    events.addEventListener("concluir_cortesia_negado", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "concluir_cortesia_negado",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'cortesia',
            tipo_acao: 'show',
            nome_campo: 'concluir_negado',
            tipo_oferta: offer_type || '',
        })
    });

    events.addEventListener("cortesia_contrato_de_assinatura", () => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "cortesia_contrato_de_assinatura",
        });
    });

    events.addEventListener("pagina_404_visualizado", () => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "pagina_404_visualizado",
        });

        sendGTMGA4Event({
            secao: 'pagina_404',
            tipo_acao: 'show'
        })
    });

    events.addEventListener("pagina_404_televendas_telefone", () => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "pagina_404_televendas_telefone",
        });

        sendGTMGA4Event({
            secao: 'pagina_404',
            nome_campo: 'televendas_telefone',
            tipo_acao: 'click'
        })
    });

    events.addEventListener("pagina_404_televendas_whatsapp", () => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "pagina_404_televendas_whatsapp",
        });

        sendGTMGA4Event({
            secao: 'pagina_404',
            nome_campo: 'televendas_whatsapp',
            tipo_acao: 'click'
        })
    });

    events.addEventListener("pagina_404_ofertas", () => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "pagina_404_ofertas",
        });

        sendGTMGA4Event({
            secao: 'pagina_404',
            nome_campo: 'ofertas',
            tipo_acao: 'click'
        })
    });

    events.addEventListener("restaurar_senha_chat_link_chat_estadao", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "restaurar_senha_chat_link_chat_estadao",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'restaurar_senha',
            nome_campo: 'chat_estadao',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("restaurar_senha_mensagem_enviar_mensagem", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "restaurar_senha_mensagem_enviar_mensagem",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'restaurar_senha',
            nome_campo: 'enviar_mensagem',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("modal_assinante_visualizado", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "show",
            genericLabel: "modal_assinante_visualizado",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'modal_assinante_visualizado',
            nome_campo: '',
            tipo_acao: 'show',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("modal_assinante_sac_capitais", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "modal_assinante_sac_capitais",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'modal_assinante_sac_capitais',
            nome_campo: '',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("modal_assinante_sac_demais_localidades", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "modal_assinante_sac_demais_localidades",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'modal_assinante_sac_demais_localidades',
            nome_campo: '',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });

    events.addEventListener("modal_assinante_continuar", (data) => {
setEvents({
            genericCategory: "ed_sqcon_jornada_checkout",
            genericAction: "click",
            genericLabel: "modal_assinante_continuar",
        });

        const { offer_type } = data

        sendGTMGA4Event({
            secao: 'modal_assinante_continuar',
            nome_campo: '',
            tipo_acao: 'click',
            tipo_oferta: offer_type || ''
        })
    });


    //  Eventos GTM
    events.addEventListener("SHOW_AUTHENTICAION", ()=>{
        TagManagerEvents.push(gtm_id, {'event':'checkout_payment'})
    })

    events.addEventListener('CHECKOUT_SEND_END', (params) => {
        if(params.response){
            if(
                params.response.content.hasOwnProperty('transaction_invalid') &&
                !!params.response.content.transaction_invalid
            ){
                TagManagerEvents.push(gtm_id,{
                    'event':'genericEvent',
                    'genericCategory':'Checkout - NT',
                    'genericAction':'transaction',
                    'genericLabel':'invalid',
                    'nonInteraction': true,
                    'transport': 'beacon'
                });
            }

        }
    });

    events.addEventListener('SHOW_AUTHENTICAION', () => {
        TagManagerEvents.push(gtm_id,{'event':'checkout_login'});
    });

    events.addEventListener('SHOW_DELIVERY', () => {
        TagManagerEvents.push(gtm_id,{'event':'checkout_address'});
    });

    events.addEventListener('SHOW_CHECKOUT', () => {
        TagManagerEvents.push(gtm_id,{'event':'checkout_payment'});
    });

    events.addEventListener('SHOW_SUCCESS', () => {
        try{
            TagManagerEvents.push(gtm_id,{'event':'forcePageView'});
        }catch (e) {
            (e instanceof Error) && Apm.captureError(e);
        }
    });

    events.addEventListener('error_page', () => {
setEvents({
            genericCategory: "checkout",
            genericAction: "show",
            genericLabel: "error_page",
        });
        sendGTMGA4Event({
            secao: 'checkout',
            nome_campo: '',
            tipo_acao: 'erro',
            tipo_oferta: ''
        })
    });
}
export default ListenerEvents;
